import React from 'react';
import CtaLink from './CtaLink';
import AnimatedWords from './AnimatedWords';
import useParallax from '../hooks/useParallax';

const ServicesHero = () => {
    const parallaxRef = useParallax(0.5);
    
    return (
        <section ref={parallaxRef} className="hero" style={{ '--hero-bg': "url('/images/services_hero.webp')" }}>
            <div className="container hero-inner flex w-full items-center lg:items-start">
                <h1 className="text-4xl md:text-6xl lg:text-[79px]">
                    <AnimatedWords lines={["Smart Logistics for a", "Fast-Moving World."]} />
                </h1>
                <div className='flex flex-col gap-10 lg:gap-0 lg:flex-row items-center lg:justify-between w-full'>
                    <div className="hero-content-row">
                        <p className="lead text-lg md:text-xl lg:text-2xl">
                            <AnimatedWords lines={["We combine innovation, experience, and technology to", "deliver efficiency that keeps your business moving forward."]} />
                        </p>
                    </div>
                    <CtaLink href="#services" primaryText="Explore Our Services" ariaLabel="Scroll to services" />
                </div>
            </div>
        </section>
    );
};

export default ServicesHero;
